import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";


function HostedSessionButton() {
  const navigate = useNavigate();
  function handleClick() {

      navigate(`/session`);
  }

  return <Button variant="primary" onClick={handleClick}>Launch Hosted Session</Button>

}

export default HostedSessionButton;